import { useCheckLogin } from '_api';
import { useGetAccountType } from '_api/queries/constants';
import { AccountType, ConstantsNameDescriptions } from '_api/types';
import { useMemo } from 'react';

const useUserForm = () => {
  const { data: accountTypes } = useGetAccountType();
  const { data: account } = useCheckLogin();
  const accountRoleOptions = useMemo<ConstantsNameDescriptions<AccountType>[]>(() => {
    if (account !== undefined && accountTypes) {
      const accountType = account.accountType;
      const initOptions = accountTypes.filter(
        (type: ConstantsNameDescriptions<AccountType>) => type.name !== 'GUARDIAN',
      );
      if (accountType === 'ORGANIZATION_ADMIN') {
        return initOptions.filter(
          (type: ConstantsNameDescriptions<AccountType>) =>
            type.name !== 'ADMIN' && type.name !== 'ORGANIZATION_ADMIN',
        );
      } else if (accountType === 'HOSPITAL_ADMIN') {
        return initOptions.filter(
          (type: ConstantsNameDescriptions<AccountType>) => type.name === 'THERAPIST',
        );
      } else {
        return initOptions;
      }
    } else return [];
  }, [accountTypes]);

  return {
    accountRoleOptions,
  };
};

export default useUserForm;
